import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useFloatingSelect } from '../../../../hooks'
import { SELECT_DROPDOWN_FLOATING_CONFIG } from '../../Select.constants'
import { useSelectKeyDown } from '../useSelectKeyDown'
import { useSelectOpenState } from '../useSelectOpenState'

import { isNotSameSelectItem } from './useSelectStates.utils'

export function useSelectStates({
  allowOpen,
  blocked,
  clearSearchOnSelect = true,
  disabled,
  dropdownFloatingConfig = SELECT_DROPDOWN_FLOATING_CONFIG,
  multi,
  options,
  value,
  onClearSearch,
  onClose,
  onOpen,
  onSelectAll,
  onSelectItem,
}) {
  const {
    activeIndex,
    context,
    elementsRef,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    isOpen,
    refs,
    setOpen,
  } = useFloatingSelect({
    ...dropdownFloatingConfig,
    disabled: disabled || blocked,
    maxWidthByRef: dropdownFloatingConfig?.maxWidthByRef ?? true,
    placement:
      dropdownFloatingConfig?.dropdownPlacement ||
      FLOATING_ELEMENT_PLACEMENT.bottom,
    onClose,
  })

  const { handleClose, handleOpen, handleToggleOpen } = useSelectOpenState({
    allowOpen,
    blocked,
    disabled,
    setOpen,
    onClose,
    onOpen,
  })

  function handleSelect(nextValue) {
    if (!multi) {
      handleClose()

      if (clearSearchOnSelect && isNotSameSelectItem({ nextValue, value })) {
        onClearSearch()
      }
    }

    onSelectItem(nextValue)
  }

  function handleSelectAll() {
    onSelectAll?.(options)
  }

  const { handleKeyDown } = useSelectKeyDown({
    activeIndex,
    disabled: disabled || blocked,
    isOpen,
    multi,
    options,
    setOpen,
    onSelect: handleSelect,
  })

  return {
    activeIndex,
    context,
    elementsRef,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    handleClose,
    handleKeyDown,
    handleOpen,
    handleSelect,
    handleSelectAll,
    handleToggleOpen,
    isOpen,
    refs,
    setOpen,
  }
}
